import { UIHeading1, Tabs, TTab } from '@cian/ui-kit';
import { Layout } from '../Layout';
import styles from './About.css';
import { TabSection } from '../TabSection';
import { FC } from 'react';

interface IAboutProps {
  title: string;
  sectionTabTitle: string;
  tabs: TTab[];
  activeTabIndex: number;
  onTabClick: (index: number) => void;
  tabContent: React.ReactNode;
}

export const About: FC<IAboutProps> = ({ title, activeTabIndex, tabContent, onTabClick, tabs, sectionTabTitle }) => {
  return (
    <TabSection className={styles['about']} sectionTabTitle={sectionTabTitle} id="about">
      <Layout>
        <div className={styles['about__wrapper']}>
          <div className={styles['about__title']}>
            <UIHeading1>{title}</UIHeading1>
          </div>

          <div className={styles['about__tabs']}>
            <Tabs
              animated
              dataTestId="about-tabs"
              items={tabs}
              onTabClick={onTabClick}
              activeTabIndex={activeTabIndex}
            />
          </div>

          {tabContent}
        </div>
      </Layout>
    </TabSection>
  );
};
